/* eslint-disable sonarjs/cognitive-complexity */
import * as Sebrae from '@sebrae/react-core';
import React, { useContext, useState } from 'react';

import { BaSeLoadingPage, BaSeStepper, BaSeTheme } from '@base/react';
import { useQuizProfileController } from '../../../../hooks/controllers/quiz-profile-controller';
import { QuizProfileContext } from './context/QuizContext';
import { Container, ContentStepper } from './quiz-profile-style';

import FirstPageQuiz from './first-page-quiz';
import QuizStep from './quiz-step';

function QuizProfile() {
  const [quizProfileData, setQuizProfileData] = React.useState([
    {
      content: function noRefCheck() {},
      title: '',
    },
  ]);

  const [status, setStatus] = useState('idle');

  const { currentStep, moduleSettings, user, handleChangeStep } =
    useContext(QuizProfileContext);
  const { getQuizProfileSteps, getProfileStepByIdInterview } =
    useQuizProfileController();
  const { isAuthenticated, login } = Sebrae.useAuth();

  React.useEffect(() => {
    if (!isAuthenticated) {
      login();
    }
  }, [isAuthenticated, login]);

  React.useEffect(() => {
    setStatus('loading');
    getQuizProfileSteps('PERFIL')
      .then((response) => {
        setStatus('fulfilled');

        let questionNumber = 1;
        response.forEach((item) => {
          if (item.hasOwnProperty('questions')) {
            if (item.sequenceStep === 8) {
              questionNumber = 1;
            }
            item.questions.forEach((question) => {
              question.description = `${questionNumber}. ${question.description}`;
              questionNumber++;
            });
          }
        });

        const newData = response?.map((q) => {
          return {
            content: () => <QuizStep key={q.sequenceStep} data={q} />,
            title: '',
          };
        });

        newData.unshift({
          content: () => <FirstPageQuiz />,
        });

        setQuizProfileData(newData);
      })
      .catch(() => {
        setQuizProfileData([]);
        setStatus('error');
      });
  }, [
    getProfileStepByIdInterview,
    handleChangeStep,
    getQuizProfileSteps,
    moduleSettings,
    user,
  ]);

  if (status === 'loading') {
    return (
      <React.Suspense fallback={<BaSeLoadingPage />}>
        Carregando!
      </React.Suspense>
    );
  }

  if (status === 'error') {
    return (
      <Container>
        <ContentStepper>Erro!</ContentStepper>
      </Container>
    );
  }

  return (
    <Container>
      <ContentStepper>
        <BaSeStepper
          activeColor={BaSeTheme.colors.institucionais.azulSebrae75}
          incompletedColor={BaSeTheme.colors.institucionais.cinzaSebrae90}
          currentStep={currentStep}
          onStepChange={(e) => {}}
          orientation="horizontal"
          steps={quizProfileData}
        />
      </ContentStepper>
    </Container>
  );
}

export default QuizProfile;
